import { motion } from "framer-motion";
import { ArrowUpRight, Sparkles } from "lucide-react";

export const MzFinalCta = ({ url }) => (
  <section
    className="py-24 sm:py-32 border-t border-neutral-100"
    style={{ background: "radial-gradient(ellipse 60% 80% at 50% 100%, rgba(212,175,55,0.12), transparent 70%)" }}
  >
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7 }}
      className="max-w-2xl mx-auto px-5 sm:px-8 text-center"
    >
      <h2 className="mz-h text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter">
        Set it up once. <span className="mz-gold-text">Get paid forever.</span>
      </h2>
      <p className="mt-5 text-[15px] text-neutral-500 leading-relaxed max-w-md mx-auto">
        Enable the Hub in one click and start selling in five minutes.
      </p>
      <a href={url} data-testid="mn-mkt-final-cta" className="mz-btn-gold mt-9 !px-9 !py-4 !text-[15px]">
        <Sparkles size={15} strokeWidth={2} />
        Enable the Hub
        <ArrowUpRight size={15} strokeWidth={2.2} />
      </a>
    </motion.div>
  </section>
);
